<template>
  <footer ref="anchor" class="footer">
    <div class="footer__content">
      <div class="font-60-68-bold footer__content-title">
        {{ content.title }}
      </div>

      <div class="footer__content-info">
        <div class="contacts">
          <div class="contacts__data">
            <div class="contacts__data-item">
              <div class="item__title">{{ content.address.title }}</div>

              <div class="font-small item__value">
                {{ content.address.value }}
              </div>
            </div>

            <div class="contacts__data-item">
              <div class="item__title">{{ content.phone.title }}</div>

              <div
                v-html-safe="content.phone.value"
                class="font-small item__value"
              />
            </div>

            <div class="contacts__data-item">
              <div class="item__title">{{ content.email.title }}</div>

              <div
                v-html-safe="content.email.value"
                class="font-small item__value"
              />
            </div>
          </div>

          <div class="contacts__map">
            <img
              :src="`/img/${content.map}`"
              alt="map"
              class="contacts__map-image"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="footer__copyright">
      <div>{{ `© ${currentYear} ${content.copyright}` }}</div>

      <div v-html-safe="content.policy" class="text__blue" />
    </div>
  </footer>
</template>

<script>
import { footerBlock } from '@/content/data'
import offsetMixin from '@/mixins/offsetMixin'
export default {
  name: 'FooterComponent',
  mixins: [offsetMixin],
  data() {
    return {
      content: footerBlock,
      currentYear: new Date().getFullYear(),
    }
  },
}
</script>

<style lang="sass" scoped>
.footer
  background: $textPrimary
  &__content
    padding: 8rem $desktopHorizontalPaddings 0
    @media (max-width: 1279px)
      padding: 4rem $mobileHorizontalPaddings 0
    &-title
      margin-bottom: 4rem
      color: $textWhite
      @media (max-width: 1279px)
        margin-bottom: 2.4rem
    &-info
      display: flex
      justify-content: space-between
      @media (max-width: 1279px)
        flex-direction: column
        justify-content: flex-start
      .contacts
        display: flex
        gap: 30px
        @media (max-width: 1279px)
          flex-direction: column
        &__data
          width: 50%
          display: flex
          flex-wrap: wrap
          margin-bottom: 3.2rem
          @media (max-width: 1279px)
            flex-direction: column
            justify-content: flex-start
            margin-bottom: 2rem
            width: 100%
          &-item
            width: 50%
            &:first-child
              width: 100%
              margin-bottom: 3.2rem

            @media (max-width: 1279px)
              width: 100%
              margin-bottom: 2rem
            .item__title
              margin-bottom: 1.5rem
              font-family: $primaryFont
              font-weight: 400
              font-size: 1.8rem
              line-height: 2.4rem
              color: $textGray
              @media (max-width: 1279px)
                margin-bottom: .8rem
                font-size: 1.6rem
                line-height: 2rem
            .item__value
              color: $textLightWhite
              ::v-deep a
                color: $textLightWhite
                text-decoration: none
        &__map
          width: 50%
          margin-bottom: 6rem
          @media (max-width: 1279px)
            margin-bottom: 4rem
            width: 100%

          &-image
            width: 100%
            height: 17.6rem
            object-fit: cover
            object-position: center
            border-radius: 24px
  &__copyright
    display: flex
    justify-content: space-between
    align-items: center
    font-family: $secondaryFont
    font-size: 1.2rem
    color: $textGray
    border-top: 1px solid $textSecondary
    padding: 2.6rem $desktopHorizontalPaddings 2.6rem
    @media (max-width: 1279px)
      padding: 2.6rem $mobileHorizontalPaddings 2.6rem

.text__blue
  color: $buttonPrimary
  cursor: pointer
</style>
